
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import Layout from '@/components/layout/Layout.vue';
    import InputSelect from '@/components/form/Input-select.vue';
    import InputText from '@/components/form/Input-text.vue';
    import InputDate from '@/components/form/Input-date.vue';
    import DatePicker from 'vue2-datepicker';
    import {ApiRepository} from "@/api";

    @Component({
        components: {
            Layout,
            InputSelect,
            InputText,
            InputDate,
            DatePicker,
        },
    })
    export default class ApplicationForm extends Vue {
        private differentDelivery = false;
        private phone = '';
        private email = '';
        private salutation = '';
        private title = '';
        private name = '';
        private surname = '';
        private birthDate = '';
        private city = '';
        private deliveryCity = '';
        private street = '';
        private deliveryStreet = '';
        private streetNumber = '';
        private deliveryStreetNumber = '';
        private postcode = '';
        private deliveryPostcode = '';
        private country = '';
        private deliveryCountry = '';
        private thirdPartyAgreement = '0';
        private emailMarketingAgreement = '0';
        private partner = '';
        private licenceAgreement = '1';
        private note = '';
        private formTop: any;


        private partnerData = {};

        // TODO: zmenit na true ked bude dodany text
        private showWelcome = true;

        private async mounted() {
            this.partner = this.$route.params.partner;

            this.partnerData = await ApiRepository.getPublicPartner(this.partner);

            this.formTop = this.$refs.formTop;
        }
        private onSubmit(event: any) {
            event.preventDefault();
            this.$validator.validate().then((valid) => {
                if (valid) {
                    const {
                        salutation,
                        phone,
                        email,
                        title,
                        name,
                        surname,
                        birthDate,
                        city,
                        deliveryCity,
                        street,
                        deliveryStreet,
                        streetNumber,
                        deliveryStreetNumber,
                        postcode,
                        deliveryPostcode,
                        country,
                        deliveryCountry,
                        thirdPartyAgreement,
                        emailMarketingAgreement,
                        partner,
                        licenceAgreement,
                        note
                    } = this;

                    let thirdPartyAgreementInt = parseInt(thirdPartyAgreement);
                    let emailMarketingAgreementInt = parseInt(emailMarketingAgreement);
                    let licenceAgreementInt = parseInt(licenceAgreement);

                    ApiRepository.postNewApplication({
                        salutation,
                        phone,
                        email,
                        title,
                        name,
                        surname,
                        birthDate,
                        city,
                        street,
                        streetNumber,
                        postcode,
                        country,
                        deliveryCity,
                        deliveryStreet,
                        deliveryStreetNumber,
                        deliveryPostcode,
                        deliveryCountry,
                        thirdPartyAgreement: thirdPartyAgreementInt,
                        emailMarketingAgreement: emailMarketingAgreementInt,
                        partner,
                        licenceAgreement: licenceAgreementInt,
                        note
                    })
                } else {
                  this.formTop.scrollIntoView({
                    behavior: 'smooth',
                  });
                }
            });
        }

        private showForm(event: any) {
            this.showWelcome = false;
        }

        @Watch('phone')
        private onChangePhone(val: any, oldVal: any) {
            if (!oldVal && val) {
                if (val === '0' || val === '+421') {
                    val = '';
                }

                this.phone = `+421${val}`;
            } else if (oldVal === '+421' && val === '+4210') {
                this.phone = '+421';
            }
        }

    }
